import React from "react";
import './Companysince.css';
const videoSrc = "https://res.cloudinary.com/dafd4nkgz/video/upload/v1742202659/video_umszch.mp4";



const Companysince = () => {
    return (
        <>
            <div className="hmsection5">
                <video autoPlay loop muted playsInline>
                    <source src={videoSrc} type="video/mp4" />
                    {/* // jfgjfhgjfgjjgh */}
                </video>
            </div>
        </>
    )
};
export default Companysince;